// Hardcoded fallback syllabus list — used automatically when the database
// has no syllabus entries yet. Add more entries here (or through the admin
// panel later) as more subject-wise syllabus files become available.

export const SYLLABUS_FALLBACK = [
  {
    id: 'syllabus-2026-27-1st-year',
    title: 'Complete Syllabus — 2026-27 Admission Batch (B.Tech 1st Year)',
    year: '1st Year',
    semester: '',
    category: 'other',
    documentUrl: 'https://drive.google.com/file/d/1-fWp8-PkjQ2MJ5PTHQOjdCB6ghoQ950t/view?usp=drive_link',
  },
];
